import { useState } from "react";
import { createSmartLinkService } from "../services/smartLinksService.js";
import { buildSmartLinkPayloadBl } from "../utils/buildPayloadBl.js";
import { generateNumericReference } from "../utils/referenceGenerator.js";
import { isLimitError } from "../components/LimitErrorModal.jsx";

export const useSmartlinksBl = () => {
  const [formData, setFormData] = useState({
    paymentConcept: "",
    amount: "",
    reference: "",
    expiration: "",
    unique: "true",
    urlCallback: "https://master.peiix.com/Master",
    promotion: false,
    name: "",
    addres: "",
    phone: "",
    email: ""
  });

  const [loading, setLoading] = useState(false);
  const [createdLink, setCreatedLink] = useState("");
  const [limitModalError, setLimitModalError] = useState(null);

  const closeLimitModal = () => setLimitModalError(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const validateForm = () => {
    if (!(Number(formData.amount) > 0)) {
      alert("El monto debe ser mayor a 0.");
      return false;
    }
    if (!formData.paymentConcept.trim()) {
      alert("El concepto de pago es obligatorio.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setCreatedLink("");

    if (!validateForm()) {
      setLoading(false);
      return;
    }

    try {

      const newReference = generateNumericReference();

      setFormData(prev => ({ ...prev, reference: newReference }));


      const payload = buildSmartLinkPayloadBl({
        ...formData,
        reference: newReference
      });

      const data = await createSmartLinkService(payload, "blumon");


      const linkUrl = data?.PayOrder || data?.smartLinkUrl;

      if (linkUrl && linkUrl.startsWith("http")) {
        setCreatedLink(linkUrl);
        window.open(linkUrl, "_blank");
      } else {
        throw new Error("No se pudo encontrar la URL de pago en la respuesta del servidor.");
      }
    } catch (error) {
      console.error(error);
      if (isLimitError(error.message)) {
        setLimitModalError(error.message);
      } else {
        alert(`Error creando SmartLink: ${error.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    loading,
    createdLink,
    limitModalError,
    closeLimitModal,
    handleChange,
    handleSubmit
  };
};